module.exports = __webpack_public_path__ + "static/media/bebfbcaf-6f92-4dec-8840-3ef3a8921bf0.d2ed073e.JPG";